'use strict';

import { find, register } from '../../../../JavaScript/Utils';

const Language = $el => {
  const $langNav = $el;
  const $langBtnOpen = find('[data-nezzo-lang-picker-btn]', $langNav);
  const $dropdownEl = $langBtnOpen.parentElement;
  const classLangPickerOpen = 'lang-picker-open';

  $langBtnOpen.addEventListener('click', () => {
    $dropdownEl.classList.toggle(classLangPickerOpen);
  })
};

register('Language', Language);
document.addEventListener('DOMContentLoaded', () => {
});
